<template>
  <div>
    <div class="card mb-4" >
      <div class="card-body p-5">
        <h6 class="sub-title">{{$t('planesYPrecios.cursos-test.titulo')}}</h6>
        

        <b-row >
	        <b-col cols="6">
                <b-form-group id="fieldset-1"  label="Selecciona un rango de edad " >
                    <b-form-input v-model="testInfo.age" type="text" name="txtAge" placeholder="Ingrese la edad" autofocus ref="inputTitle" />
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group id="fieldset-1"  label="Selecciona un objetivo" >
                    <b-form-select v-model="testInfo.goal.id" :options="lists.goals"
                        value-field="id" text-field="description" disabled-field="notEnabled" >
                        <template #first>
                            <b-form-select-option :value="0" disabled>-- {{$t('planesYPrecios.cursos-test.sub-titulo')}} --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row >
       
        <b-row >
            <b-col cols="6">
                <b-form-group id="fieldset-1"  label="Selecciona un nivel" >
                    <b-form-select v-model="testInfo.levelId" :options="lists.levels"
                        value-field="id" text-field="abbreviation" disabled-field="notEnabled">
                        <template #first>
                            <b-form-select-option :value="0" disabled>-- {{$t('planesYPrecios.cursos-test.sub-titulo-2')}} --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="6" v-show="lists.exams.length != 0 && testInfo.goal.id == GoalsConstants.OBJETIVO_4" >
                <b-form-group id="fieldset-1"  label="Selecciona un examen" >
                    <b-form-select v-model="testInfo.examId" :options="lists.exams"
                        value-field="id" text-field="name" disabled-field="notEnabled" >
                        <template #first>
                            <b-form-select-option :value="0" disabled>-- {{$t('planesYPrecios.cursos-test.sub-titulo-3')}} --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>

            </b-col>   
        </b-row >
         
        <p></p>
       <b-button variant="primary" :disabled="!flagBoton" @click="IrRutaEstudios"> {{$t('planesYPrecios.cursos-test.button')}} </b-button>
    </div>
    </div>
    <p></p>
    

    <Cursos ref="refCursos" :key="childComponentKey"
      v-if="flagMostrar"
      :goals="lists.goals"
      :levels="lists.levels"
      :group-data="group"   :flag-gestionar-cursos="false"
      :flag-show-buttons="true"
    />
  </div>
</template>

<script>
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { OBJETIVOS} from '@/assets/js/appConstants'; 
import Cursos from "./cursos";

export default {
  components: {
    Cursos,
  },
  data() {
    return {
      lang:localStorage.getItem('lang') || 'es',
      API_URL: process.env.VUE_APP_API_URL,
      GoalsConstants :OBJETIVOS,
      flagMostrar: false,
      flagBoton: false,
      childComponentKey: 0,
      testInfo:{
        age:null,
        levelId:0,
        goal:{id:0},
        examId:0
      },
      
      group: {
        id: 1,
        groupPerson: {
          groupPersonId: 1,
          typeId: 0,
          personStudent: {
            id: 0,
            courseId: 0,
            levelId: 0,
            age: 0,
            planPreviousTypeId: 10,
            planSelected: {
              typeId: 10,
              id: 3,
              planPriceId: 3,
              planPriceTypeId:10,
              type: {
                code: "003",
                name: "Plan individual",
                value: "1",
              },
              name: "$ 16 x hora",
              description: "Vigencia 6 meses.",
              tooltip: "Puedes utilizar tus horas.",
              price: 768,
              duration: 48,
            },
            goalSelected: {
              name: "003",
              description:
                "Ya conozco el idioma pero deseo mejorar mi expresión oral.",
              id: 0,
              image: "Objetivo 3.png",
            },
            examSelected: {
              name: "",
              id: 0,
              programId: 0,
            },
          },
          groupPersonEvaluation: {
            evaluationId: 0,
            evaluation: {
              id: 0,
              name: "",
              duration: 0,
            },
            duration: 0,
            timeDuration: "00:00:00",
            score: 0,
            questionAnswerSelected: [],
          },
        },
        groupCourses: [],
      },

      lists: {
        goals: [],
        levels: [],
        exams: [],
      },
    };
  },
  watch: { 
    	'testInfo.age': function(newVal, oldVal) {
			 if(newVal != oldVal){
                this.getGoals(newVal);
                this.testInfo.goal.id = 0;
                if( this.testInfo.goal != null && this.testInfo.goal.id == this.GoalsConstants.OBJETIVO_4){
                    this.getExamsByAge(this.testInfo.age);

                }
                
            }
            this.validarHabilitarBoton();
        },
        'testInfo.goal.id': function(newVal, oldVal) {
			if(newVal != oldVal){
				if(newVal == this.GoalsConstants.OBJETIVO_4){
                    this.getExamsByAge(this.testInfo.age);

                }else{
                    this.testInfo.examId = 0;
                }
            }
            this.validarHabilitarBoton();
        },
        'testInfo.examId': function(newVal, oldVal) {
			 this.validarHabilitarBoton();
        },
  },
  mounted() {
    
    this.getLevels();
    if(this.group.groupPerson.personStudent.age != 0){
        this.getGoals(this.group.groupPerson.personStudent.age);
    }
  },
  methods: {
    getGoals: function (age) {
      baseInstanceAxios
        .get(
          this.API_URL +
            `/resources/Goals/ListByAge?Age=${age}`
        )
        .then((response) => {
          if (response.data != null && response.data.list != null) {
            this.lists.goals = response.data.list;
          }
        });
    },
    getLevels: function () {
      let flag = this.lang == 'es' ? true : false;
      baseInstanceAxios
        .get(this.API_URL + `/resources/levelsfeatures/getbylevels?flagLanguage=${flag}`)
        .then((response) => {
          if (response.data != null && response.data.list != null) {
            this.lists.levels = response.data.list;
          }
        });
    },
    getExamsByAge: function(age) {
			//debugger;
			baseInstanceAxios
			.get(this.API_URL + `/Resources/Subjects/ListExamenByAge?Age=${age}`)
			.then(response => {
				if(response.data != null && response.data.list != null){
					this.lists.exams = response.data.list;
					 
				}
			});
    },
    validarHabilitarBoton(){
        this.flagBoton = false;
        if( 
            (this.testInfo.age != null && this.testInfo.levelId != 0 && this.testInfo.goal != null && this.testInfo.goal.id != this.GoalsConstants.OBJETIVO_4)
            ||
            (this.testInfo.age != null && this.testInfo.levelId != 0 && this.testInfo.goal != null && this.testInfo.goal.id == this.GoalsConstants.OBJETIVO_4 && this.testInfo.examId != 0)
        ){
            this.flagBoton = true;
        }else{
            this.flagBoton = false;
        }
        
    },
    IrRutaEstudios() {
      
      this.group.groupPerson.personStudent.age = parseInt(this.testInfo.age);
      this.group.groupPerson.personStudent.levelId = this.testInfo.levelId;

      var objGoal = this.lists.goals.find(o => o.id == this.testInfo.goal.id);
      if(objGoal != null){
        this.group.groupPerson.personStudent.goalSelected = { 
                    name: objGoal.name,
                    description: objGoal.description,
                    id: objGoal.id,
                    image: objGoal.image
                };
      }
      this.group.groupPerson.personStudent.examSelected.id = null;
      if(this.testInfo.goal.id == this.GoalsConstants.OBJETIVO_4 && this.testInfo.examId != 0 ){
        this.group.groupPerson.personStudent.examSelected.id = this.testInfo.examId;
      }
      
      this.flagMostrar = true;
      this.forceRerender(); 
    },
    forceRerender() {
      this.childComponentKey += 1;
    }
  },
};
</script>